<template>
  <div class="container-fluid mt-4 SlimTDs">
    <b-row class="mb-3">
      <b-col cols="auto">
        <span :class="`size-${ButtonSize}`">Personeller</span>
      </b-col>

      <b-col class="text-right top-buttons">
        <b-btn class="m-1" type="button" variant="danger" to="/" :size="ButtonSize">
          <i class="material-icons mifix">arrow_back</i>
          <span class="ml-1" v-if="ScreenWidth >= 380">Ana Ekran</span>
        </b-btn>

        <b-btn to="/Staff/Add" class="btn btn-info m-1" :size="ButtonSize">
          <i class="material-icons mifix">add</i>
          <span class="ml-1" v-if="ScreenWidth >= 350">Personel Ekle</span>
        </b-btn>
      </b-col>
    </b-row>

    <b-table
      striped
      hover
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :items="Staff"
      :fields="fields"
      responsive
    >
      <template v-slot:cell(Name)="data">
        <div class="ws-nowrap">{{ data.item.Name }}</div>
      </template>

      <template v-slot:cell(RoleName)="data">
        <div class="ws-nowrap">{{ data.item.RoleName }}</div>
      </template>

      <template v-slot:cell(RegDate)="data">
        <div class="ws-nowrap">{{ data.item.RegDate }}</div>
      </template>

      <template v-slot:cell(Actions)="data">
        <b-btn :to="`/Staff/${data.item.ID}`" class="mr-2">Düzenle</b-btn>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
import datetr from "@/Date";

export default {
  data() {
    return {
      Enums: {
        UserStatus: {
          0: "Pasif",
          1: "Aktif",
          2: "Onay Bekliyor"
        }
      },
      sortBy: "RegTime",
      sortDesc: false,
      fields: [
        { key: "Name", label: "İsim Soyisim", sortable: true },
        { key: "RoleName", label: "Rolü", sortable: true },
        { key: "Username", label: "Kullanıcı Adı", sortable: true },
        { key: "Phone", label: "Telefon", sortable: true },
        { key: "RegDate", label: "Kayıt Tarihi", sortable: true },
        { key: "Status", label: "Durum", sortable: true },
        { key: "Actions", label: "İşlem", sortable: false }
      ]
    };
  },
  computed: {
    ...mapState(["StoreData", "ScreenWidth", "ButtonSize"]),
    Roles() {
      return this.StoreData.Roles ? this.StoreData.Roles : {};
    },
    Staff() {
      let _Staff = [];

      if (this.StoreData.Staff) {
        for (let i in this.StoreData.Staff) {
          const _User = this.StoreData.Staff[i];

          _Staff.push({
            ID: _User.ID,
            Name: _User.Name,
            RoleName: _User.RoleName,
            Username: _User.Username,
            Phone: _User.Phone,
            RegDate: this.date(_User.RegTime, "dd.mm.yyyy - HH:MM"),
            RegTime: this.date(_User.RegTime, "yyyymmddHHMM"),
            Status: this.Enums.UserStatus[_User.Status]
          });
        }
      }

      return _Staff;
    }
  },
  methods: {
    date: (timestamp, format = "dd.mm.yyyy") => {
      return datetr(timestamp, format);
    }
  },
  mounted() {
    this.$store.subscribe(async () => {
      await this.$nextTick();
      await this.$forceUpdate();
    });
  }
};
</script>
